import { PlaceTileModel } from '@/models/editor_modes/PlaceTileModel';
import type { IPlaceTileModel } from '@/interfaces/models';
import { TileManagerFactory } from '@/factories/TileManagerFactory';
import Context from '@/context';
import { ConnectionModelFactory } from '@/factories/ConnectionModelFactory';

export class TileSelectModelFactory {
  constructor(
    private readonly tileManagerModelFactory: TileManagerFactory,
    private readonly connectionModelFactory: ConnectionModelFactory,
  ) {}

  create(context: Context): IPlaceTileModel {
    const tileManagerModel = this.tileManagerModelFactory.create(context);
    const connectionModel = this.connectionModelFactory.create(tileManagerModel);
    return new PlaceTileModel(tileManagerModel, connectionModel, undefined, context);
  }
}
